import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@karma/components/Typography';
import useTagIsOutOfStock from 'hooks/useTagIsOutOfStock';
import calcTagDiscount from 'functions/calcTagDiscount';
import { ImageBadge, Discount, OutOfStockOverlay } from './TagRegularImageOverlay.style';

const TagRegularImageOverlay = ({ tag }) => {
  const { t } = useTranslation();
  const isOutOfStock = useTagIsOutOfStock(tag.marker);

  const discount = useMemo(() => {
    if (isOutOfStock) return null;

    return calcTagDiscount(tag.price);
  }, [isOutOfStock, tag.price]);

  return (
    <>
      {!!discount && (
        <Discount>
          <Typography variant="labelExtraSmallUppercase">{discount}%</Typography>
        </Discount>
      )}
      {isOutOfStock && (
        <>
          <OutOfStockOverlay />
          <ImageBadge>
            <Typography variant="labelExtraSmallUppercase">{t('app:outOfStock')}</Typography>
          </ImageBadge>
        </>
      )}
    </>
  );
};

export default TagRegularImageOverlay;
